<div class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4"
  (click)="onClose()">
  <div
    class="bg-white dark:bg-slate-900 w-full max-w-5xl max-h-[90vh] rounded-[2rem] shadow-2xl border border-slate-100 dark:border-slate-800 overflow-hidden flex flex-col"
    (click)="$event.stopPropagation()">
    <div class="px-6 py-4 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between shrink-0">
      <div>
        <h3 class="text-base font-extrabold text-slate-800 dark:text-slate-100">รายละเอียดกะ</h3>
        <p class="text-xs text-slate-400 mt-0.5 font-medium" *ngIf="detail() as d">
          {{ d.shiftCode || ('#' + d.id) }} · {{ d.siteName || '—' }}
        </p>
      </div>
      <button type="button" (click)="onClose()"
        class="w-9 h-9 rounded-xl text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer border-none bg-transparent">
        <span class="material-icons text-[20px]">close</span>
      </button>
    </div>

    <div class="p-6 overflow-y-auto flex-1 space-y-6" *ngIf="!isLoading(); else loadingTpl">
      <ng-container *ngIf="detail() as d; else emptyTpl">
        <!-- Header meta -->
        <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
          <div class="rounded-2xl bg-slate-50 dark:bg-slate-800/60 p-3">
            <div class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">คนเปิด</div>
            <div class="text-sm font-bold text-slate-800 dark:text-slate-100 mt-1">{{ d.openUserName || '—' }}</div>
          </div>
          <div class="rounded-2xl bg-slate-50 dark:bg-slate-800/60 p-3">
            <div class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">คนปิด</div>
            <div class="text-sm font-bold text-slate-800 dark:text-slate-100 mt-1">{{ d.closeUserName || '—' }}</div>
          </div>
          <div class="rounded-2xl bg-slate-50 dark:bg-slate-800/60 p-3">
            <div class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">เปิด / ปิด</div>
            <div class="text-xs font-semibold text-slate-700 dark:text-slate-200 mt-1">
              {{ d.openDate | date:'dd/MM/yyyy HH:mm':'':'en-GB' }}
              <span class="text-slate-400">→</span>
              {{ d.closeDate ? (d.closeDate | date:'dd/MM/yyyy HH:mm':'':'en-GB') : 'ยังเปิด' }}
            </div>
          </div>
          <div class="rounded-2xl bg-slate-50 dark:bg-slate-800/60 p-3">
            <div class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">สถานะ</div>
            <div class="mt-1">
              <span class="inline-flex px-2.5 py-1 rounded-full text-[11px] font-bold"
                [ngClass]="d.isOpen
                  ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                  : 'bg-slate-200/80 text-slate-600 dark:bg-slate-700 dark:text-slate-300'">
                {{ d.isOpen ? 'เปิด' : 'ปิด' }}
              </span>
            </div>
          </div>
        </div>

        <!-- Summary cards -->
        <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
          <div class="rounded-2xl border border-amber-100 dark:border-amber-900/40 bg-amber-50/50 dark:bg-amber-900/10 p-4">
            <div class="text-[10px] font-bold text-amber-600/80 uppercase tracking-wider">ยอดระบบรวม</div>
            <div class="text-xl font-black text-slate-900 dark:text-white mt-1">{{ formatMoney(d.system.totalAmount) }}</div>
            <div class="text-[11px] text-slate-500 mt-1">
              Fee {{ formatMoney(d.system.totalFee) }} · VAT {{ formatMoney(d.system.totalVat) }}
            </div>
          </div>
          <div class="rounded-2xl border border-slate-100 dark:border-slate-700 p-4">
            <div class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">ใบเสร็จ</div>
            <div class="text-xl font-black text-slate-900 dark:text-white mt-1">{{ d.system.receiptCount | number }}</div>
          </div>
          <div class="rounded-2xl border border-slate-100 dark:border-slate-700 p-4">
            <div class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">ยืนยัน Cash / QR</div>
            <div class="text-sm font-bold text-slate-800 dark:text-slate-100 mt-1">
              {{ formatMoney(d.declared.cash) }} / {{ formatMoney(d.declared.qr) }}
            </div>
            <div class="text-[10px] text-slate-400 mt-1">อ่านอย่างเดียว</div>
          </div>
          <div class="rounded-2xl border p-4"
            [ngClass]="(hasVarianceIssue(d.variance?.cash) || hasVarianceIssue(d.variance?.qr))
              ? 'border-rose-200 dark:border-rose-900/50 bg-rose-50/40 dark:bg-rose-900/10'
              : 'border-emerald-100 dark:border-emerald-900/40 bg-emerald-50/40 dark:bg-emerald-900/10'">
            <div class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">ผลต่าง Cash / QR</div>
            <div class="text-sm font-black mt-1"
              [ngClass]="(hasVarianceIssue(d.variance?.cash) || hasVarianceIssue(d.variance?.qr))
                ? 'text-rose-600 dark:text-rose-400'
                : 'text-emerald-700 dark:text-emerald-400'">
              {{ formatMoney(d.variance?.cash) }} / {{ formatMoney(d.variance?.qr) }}
            </div>
            <div class="text-[10px] text-slate-400 mt-1" *ngIf="isVarianceOk(d.variance?.cash) && isVarianceOk(d.variance?.qr)">
              ยอดตรง
            </div>
          </div>
        </div>

        <!-- byFeeType -->
        <div>
          <h4 class="text-sm font-extrabold text-slate-800 dark:text-slate-100 mb-3">สรุปตามประเภทรับชำระ</h4>
          <div class="overflow-x-auto rounded-2xl border border-slate-100 dark:border-slate-700">
            <table class="w-full text-left text-sm">
              <thead class="bg-slate-50 dark:bg-slate-800/80 text-[11px] font-bold text-slate-400 uppercase tracking-wider">
                <tr>
                  <th class="px-4 py-3">ประเภท</th>
                  <th class="px-4 py-3 text-right">Fee</th>
                  <th class="px-4 py-3 text-right">VAT</th>
                  <th class="px-4 py-3 text-right">ยอดจริง</th>
                  <th class="px-4 py-3 text-center">จำนวน</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
                <tr *ngFor="let row of d.system.byFeeType">
                  <td class="px-4 py-2.5 font-semibold text-slate-700 dark:text-slate-200">{{ row.feeTypeName || '—' }}</td>
                  <td class="px-4 py-2.5 text-right">{{ formatMoney(row.totalFee) }}</td>
                  <td class="px-4 py-2.5 text-right">{{ formatMoney(row.totalVat) }}</td>
                  <td class="px-4 py-2.5 text-right font-black text-slate-900 dark:text-white">{{ formatMoney(row.totalAmount) }}</td>
                  <td class="px-4 py-2.5 text-center">{{ row.count | number }}</td>
                </tr>
                <tr *ngIf="!d.system.byFeeType.length">
                  <td colspan="5" class="px-4 py-8 text-center text-slate-400">ไม่มีสรุปประเภทรับชำระ</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- finances -->
        <div>
          <h4 class="text-sm font-extrabold text-slate-800 dark:text-slate-100 mb-3">
            รายการรับชำระในกะ
            <span class="text-slate-400 font-semibold">({{ d.finances.length | number }})</span>
          </h4>
          <div class="overflow-x-auto rounded-2xl border border-slate-100 dark:border-slate-700 max-h-72">
            <table class="w-full text-left text-sm">
              <thead class="sticky top-0 bg-slate-50 dark:bg-slate-800 text-[11px] font-bold text-slate-400 uppercase tracking-wider">
                <tr>
                  <th class="px-4 py-3">ใบเสร็จ</th>
                  <th class="px-4 py-3">ชื่อ / อ้างอิง</th>
                  <th class="px-4 py-3">ประเภท</th>
                  <th class="px-4 py-3 text-right">Fee</th>
                  <th class="px-4 py-3 text-right">VAT</th>
                  <th class="px-4 py-3 text-right">ยอดจริง</th>
                  <th class="px-4 py-3">ชำระเมื่อ</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
                <tr *ngFor="let f of d.finances">
                  <td class="px-4 py-2 font-mono text-xs font-bold text-sky-600 dark:text-sky-400">{{ f.receiptId || '—' }}</td>
                  <td class="px-4 py-2 text-slate-600 dark:text-slate-300 max-w-[10rem] truncate" [title]="f.name || ''">
                    {{ f.name || '—' }}
                  </td>
                  <td class="px-4 py-2">{{ f.feeTypeName || '—' }}</td>
                  <td class="px-4 py-2 text-right">{{ formatMoney(f.fee) }}</td>
                  <td class="px-4 py-2 text-right">{{ formatMoney(f.vat) }}</td>
                  <td class="px-4 py-2 text-right font-bold">{{ formatMoney(f.amount) }}</td>
                  <td class="px-4 py-2 text-xs text-slate-500 whitespace-nowrap">
                    {{ f.paidDate | date:'dd/MM/yyyy HH:mm':'':'en-GB' }}
                  </td>
                </tr>
                <tr *ngIf="!d.finances.length">
                  <td colspan="7" class="px-4 py-8 text-center text-slate-400">ไม่มีรายการรับชำระในกะนี้</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container>
    </div>

    <ng-template #loadingTpl>
      <div class="p-16 text-center text-slate-400 text-sm">กำลังโหลดรายละเอียด...</div>
    </ng-template>
    <ng-template #emptyTpl>
      <div class="p-16 text-center text-slate-400 text-sm">ไม่พบข้อมูลกะ</div>
    </ng-template>

    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-800 shrink-0">
      <button type="button" (click)="onClose()"
        class="w-full py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-bold text-slate-600 dark:text-slate-300 cursor-pointer bg-transparent hover:bg-slate-50 dark:hover:bg-slate-800">
        ปิด
      </button>
    </div>
  </div>
</div>
